export default "__VITE_ASSET__NYWN5JIG__"